import { render } from "./MatchdayTakeoverV2.vue?vue&type=template&id=a520a3a4&scoped=true"
import script from "./MatchdayTakeoverV2.vue?vue&type=script&lang=js"
export * from "./MatchdayTakeoverV2.vue?vue&type=script&lang=js"

import "./MatchdayTakeoverV2.vue?vue&type=style&index=0&id=a520a3a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a520a3a4"]])

export default __exports__